export default "__VITE_ASSET__qFDmno0A__"